import { useAppSetting } from "@/hooks/useAppSettings";

const DEFAULT_FOOTER =
  "©️2026 Pokémon / Nintendo / Creatures / GAME FREAK. TM, ®️ Nintendo.";

interface FooterLabelProps {
  variant?: "voting" | "tv";
}

export function FooterLabel({ variant = "voting" }: FooterLabelProps) {
  const { data: label = DEFAULT_FOOTER } = useAppSetting(
    "footer_label",
    DEFAULT_FOOTER
  );

  if (variant === "tv") {
    return (
      <div className="fixed bottom-1 right-3 z-40 pointer-events-none text-[0.7vw] 2xl:text-xs text-[#8b8698]/70">
        {label}
      </div>
    );
  }

  return (
    <div className="w-full px-3 pb-3 pt-2 text-right text-[10px] sm:text-xs text-muted-foreground/70">
      {label}
    </div>
  );
}
